module.exports = __webpack_public_path__ + "img/5.16bff197.png";